// extracted by mini-css-extract-plugin
export default {"wrapper":"Styles_wrapper__XcZt5","bottomItem":"Styles_bottomItem__ih2dV","show":"Styles_show__AJtyT","hidden":"Styles_hidden__69OvF","barContainer":"Styles_barContainer__qyf5U"};